function ErrorPage() {
  return (
    <>
      <h1>Oops! the page you are looking for might be in another universe!</h1>
    </>
  );
}

export default ErrorPage;
